module.exports = __webpack_public_path__ + "static/media/soldier.a038d02a.png";